import React from 'react';
import Store from '../_utils/tools/store';
import showLoginPopup from "../_utils/login-launcher";

const GuestMenuItems = [
  {
    title: 'Sign In or Create Account',
    iconName: 'sign-in',
    clickHandler: () => { showLoginPopup(); },
  },
  {
    title: 'Track Orders',
    iconName: 'track-orders',
    clickHandler: () => window.location.href = window.urls.trackOrders
  },
  {
    title: 'Help',
    iconName: 'help',
    clickHandler: () => window.location.href = '/about/help'
  }
];

const GuestMenu = () => (
  GuestMenuItems.map(({ title, iconName, clickHandler }) => (
    <button
      key={iconName}
      type='button'
      className='dropdown-item'
      onClick={clickHandler}
    >
      <i role='presentation' className={`skinny-icon ${iconName}`} />
      <span className='text-nowrap'>{title}</span>
      {title.startsWith('Sign In') && <small
        className='get-more d-block'
        role='presentation'
      >
        Get more out of <span className='store-name'>{Store.name}</span>
      </small>}
    </button>
  ))
);

export default GuestMenu;
